/**
 * The three answers an anticoagulant question can carry (KIN-659).
 *
 * "Not selected" is a real answer, not a placeholder. A referral that says "No" when
 * nobody was asked is a clinical claim the practice did not make — the defect behind
 * KIN-656 — so the empty value has to be reachable, and reachable again after a mistaken
 * Yes or No.
 *
 * The backend needs no third code for it: anything that is neither "true" nor "false"
 * reaches the message as "Not specified".
 */
export const ANTICOAGULANT_OPTIONS = [
  {
    label: "Not selected",
    value: "",
  },
  {
    label: "Yes",
    value: "true",
  },
  {
    label: "No",
    value: "false",
  },
];
